var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    viewBox: "0 0 15.5 15.5",
    className: "credit-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "credit-svg__circle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.54,.99c-.38-.21-.77-.39-1.19-.54l-.5,1.41c.33,.12,.65,.26,.96,.43l.73-1.31Z",
    shapeRendering: "geometricPrecision"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.32,4.91l1.34-.68c-.2-.39-.43-.76-.69-1.11-.26-.35-.55-.68-.86-.98l-1.04,1.08c.25,.24,.49,.5,.7,.79,.21,.28,.4,.58,.55,.89Z",
    shapeRendering: "geometricPrecision"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.19,14.68c.35-.17,.69-.36,1.01-.59l-.86-1.23c-.27,.19-.57,.36-.87,.51-.93,.45-1.95,.66-2.97,.62-1.05-.04-2.07-.35-2.97-.89-.9-.54-1.65-1.3-2.18-2.21s-.82-1.93-.85-2.98,.21-2.09,.69-3.02c.48-.93,1.19-1.73,2.05-2.32,.87-.59,1.87-.95,2.92-1.05,1.04-.1,2.1,.07,3.06,.48l.59-1.38C9.62,.12,8.31-.09,7.02,.03c-1.3,.12-2.54,.57-3.62,1.3S1.45,3.05,.85,4.21C.26,5.37-.03,6.66,0,7.96s.4,2.57,1.05,3.7c.66,1.12,1.58,2.06,2.7,2.74s2.38,1.05,3.68,1.1c1.26,.05,2.5-.21,3.63-.75h0s.04-.02,.06-.03c.02-.01,.04-.02,.06-.04h0Z",
    shapeRendering: "geometricPrecision"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.32,6.07l-1.46,.33c.08,.34,.12,.69,.14,1.04,.02,.35,0,.7-.04,1.05l1.49,.18c.05-.43,.07-.87,.04-1.3-.02-.44-.08-.87-.17-1.29Z",
    shapeRendering: "geometricPrecision"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.11,10.96c-.18,.3-.39,.59-.61,.85l1.14,.97c.28-.33,.54-.68,.76-1.06,.22-.38,.42-.77,.57-1.17l-1.4-.54c-.13,.33-.28,.64-.46,.94Z",
    shapeRendering: "geometricPrecision"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "credit-svg__check"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "6.35 10.24 6.88 9.71 7.41 10.23 6.88 9.71 6.35 10.24",
    shapeRendering: "geometricPrecision"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "9.74 5.69 9.21 6.23 6.86 8.64 6.28 8.06 5.74 7.54 4.69 8.61 5.22 9.13 6.35 10.24 6.88 9.71 7.41 10.23 10.29 7.27 10.81 6.74 9.74 5.69",
    shapeRendering: "geometricPrecision"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 9.86,
    width: 0.75,
    height: 0.75,
    transform: "translate(-5.24 7.95) rotate(-45.43)",
    shapeRendering: "geometricPrecision"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditIcon);
export default __webpack_public_path__ + "static/media/creditIcon.9734bbde130eb755cf624ce85a204a02.svg";
export { ForwardRef as ReactComponent };